import { PropsWithChildren } from "react";

import { Alert } from "@mui/material";

export function NoticeBanner({ children }: PropsWithChildren) {
  return (
    <Alert severity="error" icon={false}>
      {children}
    </Alert>
  );
}
